


// import React, { useContext } from "react";
// import Swal from "sweetalert2";
// import { BsWhatsapp } from "react-icons/bs";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// // import "./ReferUI.css"; 

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   if (!user) return null;

//   const copyCode = () => {
//     navigator.clipboard.writeText(user.referral_code);
//     Swal.fire({
//       icon: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1000,
//     });
//   };

//   // const shareText = `Play JokerLudo and earn daily! Join using my code: ${user.referral_code} \nLink: https://jokerludo.com/login/${user.referral_code}`;
// const shareText = `🔥 Hello Dost 👋

// Apni Site JokerLudo par Game Khelo aur Daily Paisa Jeeto 💸

// 🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

// 🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

// 👉 Join Now:
// https://jokerludo.com/login/${user.referral_code}

// 🎯 Referral Code: ${user.referral_code}`;
//   return (
//     <div className="refer-page-wrapper leftContainer mt-5 pt-5">
//       <div className="refer-main-container">
        
//         {/* Title Section */}
//         <div className="refer-title-section">
//           <h1>Invite & Earn</h1>
//           <p>Share your code and get 3% of your friend's winnings!</p>
//         </div>

//         {/* Unique Referral Code Card */}
//         <div className="referral-code-card">
//           <label>YOUR UNIQUE REFERRAL CODE</label>
//           <div className="code-row">
//             <div className="dashed-code-box">
//               {user.referral_code}
//             </div>
//             <button className="copy-btn-blue" onClick={copyCode}>
//               <FiCopy /> Copy
//             </button>
//           </div>
//         </div>

//         {/* WhatsApp Button */}
//         <a 
//           href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
//           className="whatsapp-btn-full"
//         >
//           <BsWhatsapp className="wa-icon" /> WhatsApp
//         </a>

//         {/* Stats Divider */}
//         <div className="stats-divider">
//           <div className="divider-line"></div>
//           <span>YOUR STATS</span>
//           <div className="divider-line"></div>
//         </div>

//         {/* Stats Grid */}
//         <div className="refer-stats-grid">
//           <div className="stat-box purple-box">
//             <div className="stat-content">
//               <h2>{user.referral_user?.length || 0}</h2>
//               <p>Total Players</p>
//             </div>
//             <img src="/images/trophy-bg.png" alt="" className="box-bg-icon" />
//           </div>

//           <div className="stat-box orange-box">
//             <div className="stat-content">
//               <h2>₹{user.referral_earning || 0}</h2>
//               <p>Total Earnings</p>
//             </div>
//             <img src="/images/money-bag.png" alt="" className="box-bg-icon" />
//           </div>
//         </div>

//         {/* How It Works */}
//         <div className="how-it-works-card mb-5">
//           <h3><span className="info-icon">🛈</span> How It Works</h3>
          
//           <div className="step-row">
//             <div className="step-number">01</div>
//             <p>You can refer and <strong>Earn 3%</strong> of your referral winning, every time.</p>
//           </div>

//           <div className="step-row">
//             <div className="step-number">02</div>
//             <p>If your player wins <strong>₹10,000</strong>, you instantly get <strong>₹300</strong> in your wallet.</p>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Refer;


import React, { useContext } from "react";
import Swal from "sweetalert2";
import { BsWhatsapp, BsFacebook, BsTelegram, BsShareFill } from "react-icons/bs";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
// import "../css/referNew.css"; // Separate Modern CSS file

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    Swal.fire({
      icon: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1000,
    });
  };

//   const shareText = `🔥 Hello Dost 👋

// Apni Site JokerLudo par Game Khelo aur Daily Paisa Jeeto 💸

// 5% commssion

// 🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

// 🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

// 👉 Join Now:
// https://jokerludo.com/login/${user.referral_code}

// 🎯 Referral Code: ${user.referral_code}`;

const shareText = `🔥 Hello Dost 👋

Apni Site JokerLudo par Game Khelo aur Daily Paisa Jeeto 💸

💰 5% Commission every game par!

🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

👉 Join Now:
https://jokerludo.com/login/${user.referral_code}

🎯 Referral Code: ${user.referral_code}`;

  return (
    <div className="refer-page-layout mt-5 pt-5">
      <div className="refer-main-container">

        {/* 1. Your Referral Earnings Section */}
        <div className="referral-box-card">
          <div className="card-header-black">Your Referral Earnings</div>
          <div className="earnings-flex-row">
            <div className="earning-col">
              <span className="earning-title">Referred Players</span>
              <span className="earning-value">{user.referral_user?.length || 0}</span>
            </div>
            <div className="vertical-divider"></div>
            <div className="earning-col">
              <span className="earning-title">Referral Earning</span>
              <span className="earning-value">₹{user.referral_earning || 0}</span>
            </div>
          </div>
        </div>

        {/* 2. Referral Code Section */}
        <div className="referral-box-card">
          <div className="card-header-black">Referral Code</div>
          <div className="code-card-body">
            
            <div className="dashed-input-row">
              <div className="dashed-code-box">
                {user.referral_code || "450216"}
              </div>
              <button className="copy-btn-orange" onClick={copyCode}>
                Copy
              </button>
            </div>

            <div className="or-divider-text">OR</div>

            {/* Social Share Icons Row */}
            <div className="social-icons-row">
              <a 
                href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
                className="social-icon-btn whatsapp-bg"
              >
                <BsWhatsapp />
              </a>
              <a 
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`https://jokerludo.com/login/${user.referral_code}`)}`} 
                target="_blank" 
                rel="noreferrer"
                className="social-icon-btn facebook-bg"
              >
                <BsFacebook />
              </a>
              <a 
                href={`https://telegram.me/share/url?url=${encodeURIComponent(`https://jokerludo.com/login/${user.referral_code}`)}&text=${encodeURIComponent(shareText)}`} 
                target="_blank" 
                rel="noreferrer"
                className="social-icon-btn telegram-bg"
              >
                <BsTelegram />
              </a>
              <button 
                className="social-icon-btn copy-icon-bg"
                onClick={copyCode}
              >
                <FiCopy />
              </button>
            </div>

          </div>
        </div>

        {/* 3. How It Works Section */}
        <div className="referral-box-card mb-5">
          <div className="card-header-black">How It Works</div>
          <div className="how-it-works-body">
            <p>1. You can refer and Earn 3% of your referral winning, every time</p>
            <p>2. Like if your player plays for More Amount. 10000 and wins, You will get Ruppe. 300 as referral amount.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Refer;
